<i [ngClass]="bootstrapIconName" [ngStyle]="{ 'font-size': bootstrapIconSize }"></i>
